export const container = {
  display: 'flex',
  justifyContent: 'space-around',
};
